// project styling
import '../scss/_main.scss'

// base scripts
// do not change
import './base';

// Import plugins
// here you are able to add you own scripts
import './plugins';